import React from "react";
import {Redirect} from "react-router";
//import ReactDOM from "react-dom";
import withStyles from "@material-ui/core/styles/withStyles";
import UpdateDoctorTS from "components/Forms/DoctorForm/AddExistingForm.jsx";

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";

import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardText from "components/Card/CardText.jsx";
import CardBody from "components/Card/CardBody.jsx";

const styles = {
    cardCategoryWhite: {
        color: "rgba(255,255,255,.62)",
        margin: "0",
        fontSize: "14px",
        marginTop: "0",
        marginBottom: "0"
    },
    cardTitleWhite: {
        color: "#FFFFFF",
        marginTop: "0px",
        minHeight: "auto",
        fontWeight: "300",
        fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
        marginBottom: "3px",
        textDecoration: "none"
    }
};
class updateDoctors extends React.Component {

    render() {
        const {classes} = this.props;
        return (
            <div>
                <GridContainer>
                    <GridItem xs={12} sm={12} md={12}>
                        <Card>
                            <CardHeader color="info" text>
                                <CardText color="info">
                                    <h4 className={classes.cardTitle}>Update Doctor</h4>
                                </CardText>
                            </CardHeader>
                            <CardBody>
                                <GridContainer>
                                    <GridItem xs={12} md={12} sm={12}>
                                        <UpdateDoctorTS id={this.props} subscription="done"/>
                                    </GridItem>
                                </GridContainer>
                            </CardBody>
                        </Card>
                    </GridItem>
                </GridContainer>
            </div>)
    }
}

export default withStyles(styles)(updateDoctors);



// WEBPACK FOOTER //
// ./src/views/Doctors/updateDoctorTS.jsx